import { Status } from "./Status";


export class InvoiceTypeSmartEnum {
    static Storage = new Status("Storage", 1, "pill--blue");
    static Recall = new Status("Recall", 2, "pill--orange");
    static Disposal = new Status("Disposal", 3, "pill--red");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "InvoiceTypeSmartEnum";
    }
}
